import { formatSession } from '@/app/_shared/utils'
import { type EntityReference } from '@/app/_shared/satelliteEntity/types'
import { type UserRole } from '@/app/_shared/enums'
import { signIn, useSession } from 'next-auth/react'

interface UseUserResult {
	isAdmin: boolean
	isGuest: boolean
	isEngineer: boolean
	isSiteManager: boolean
	name: string
	id?: number
	role: UserRole | null
	avatarUrl: string | null
	lastLoginAt: Date | null
	userSite: (EntityReference & { abbreviation: string | null }) | null
	userSecondarySites: EntityReference[]
	jmtAccess: boolean
	qmtAccess: boolean
}

export const useUser = (): UseUserResult => {
	const { data: session } = useSession({
		required: true,
		onUnauthenticated: () => signIn('azure-ad'),
	})
	const formattedSession = formatSession(session)
	return formattedSession
}
